import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill, EmptyState } from "@/components/Bits";
import { toast } from "sonner";
import { ShieldCheck, QrCode } from "@phosphor-icons/react";

export default function Pickup() {
  const [students, setStudents] = useState([]);
  const [logs, setLogs] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const [s, l] = await Promise.all([api.get("/students"), api.get("/pickup-logs")]);
    setStudents(s.data); setLogs(l.data);
  };
  useEffect(() => { load(); }, []);

  const logAction = async (action) => {
    if (!selected) return;
    try {
      await api.post("/pickup-logs", {
        student_id: selected.student_id,
        action,
        by_name: selected.pickup_authorized?.[0] || "Parent",
        relationship: "Parent",
      });
      toast.success(`Logged ${action}`);
      load();
    } catch { toast.error("Could not log"); }
  };

  return (
    <div>
      <PageHeader eyebrow="Security" title="Pickup & drop" subtitle="QR check-in/out with authorised guardian logs." />

      <div className="grid lg:grid-cols-3 gap-6">
        <Panel title="Choose a child" testid="pickup-students">
          <div className="grid grid-cols-2 gap-2 max-h-[500px] overflow-y-auto">
            {students.map(s => (
              <button key={s.student_id} onClick={() => setSelected(s)} className={`p-3 rounded-2xl text-left text-sm border ${selected?.student_id === s.student_id ? "bg-terracotta text-white border-terracotta" : "bg-white border-border"}`} data-testid={`pickup-${s.student_id}`}>
                <div className="font-semibold truncate">{s.name}</div>
                <div className={`text-xs ${selected?.student_id === s.student_id ? "text-white/80" : "text-ink-soft"}`}>{s.class_name}</div>
              </button>
            ))}
          </div>
        </Panel>

        <Panel className="lg:col-span-2 flex flex-col items-center justify-center text-center" testid="pickup-action">
          {selected ? (
            <>
              <div className="w-32 h-32 mx-auto rounded-3xl bg-paper-alt flex items-center justify-center">
                <QrCode size={80} weight="duotone" />
              </div>
              <h3 className="font-heading text-2xl font-bold mt-4">{selected.name}</h3>
              <div className="text-sm text-ink-soft mt-1">{selected.class_name} · Authorised: {(selected.pickup_authorized || []).join(", ") || "—"}</div>
              <div className="mt-6 flex gap-3 justify-center">
                <button onClick={() => logAction("check_in")} className="px-6 py-3 rounded-full bg-sage-deep text-white font-semibold" data-testid="check-in-btn">Check-in (drop-off)</button>
                <button onClick={() => logAction("check_out")} className="px-6 py-3 rounded-full bg-terracotta text-white font-semibold" data-testid="check-out-btn">Check-out (pickup)</button>
              </div>
            </>
          ) : <EmptyState title="Pick a child" hint="Tap a child from the list to scan or log a check-in / check-out." />}
        </Panel>
      </div>

      <Panel title="Recent activity" className="mt-6" testid="pickup-logs">
        {logs.length === 0 ? <EmptyState /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs uppercase text-ink-soft tracking-wider"><th className="py-2">Time</th><th>Child</th><th>Action</th><th>By</th></tr></thead>
              <tbody>
                {logs.slice(0, 30).map(l => {
                  const s = students.find(x => x.student_id === l.student_id);
                  return (
                    <tr key={l.pickup_id} className="border-t border-border">
                      <td className="py-2">{new Date(l.ts).toLocaleString()}</td>
                      <td className="py-2 font-medium">{s?.name || "—"}</td>
                      <td className="py-2"><Pill tone={l.action === "check_in" ? "sage" : "terracotta"}>{l.action.replace("_", " ")}</Pill></td>
                      <td className="py-2">{l.by_name} ({l.relationship})</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
